export const handleOperationSuccess = (errorMessage, loading, prevLoadingState, type) => {
  return !errorMessage.message && !loading.state && loading.type === type && prevLoadingState
}